import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from './Hero/Hero';
import PrivacyBody from './PrivacyBody/PrivacyBody';

const Terms = () => {

    return (
        <div className="privacy-view">
            <Helmet>
                <title>HPP&apos;s Privacy Policy | Hudson Pacific Properties</title>
                <meta name="description" property="og:description" content="Read Hudson Pacific Properties Privacy Policy here." />
            </Helmet>
            <Hero />
            <PrivacyBody />
        </div>
    );
};

export default Terms;
